// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1z4oM","disabled":"FileBtn_disabled__3OC7N","warn":"FileBtn_warn__hPJsP","fade":"FileBtn_fade__1F0SB"};